import React from 'react';
import { Incident } from '../types';
import {
  CheckCircleIcon,
} from '@heroicons/react/24/outline';

interface IncidentCardProps {
  incident: Incident;
  onResoudre?: (incidentId: string) => void;
}

const typeConfig: Record<string, { bg: string; text: string; label: string }> = {
  alea: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Aléa' },
  securite: { bg: 'bg-red-100', text: 'text-red-700', label: 'Sécurité' },
  meteo: { bg: 'bg-sky-100', text: 'text-sky-700', label: 'Météo' },
  technique: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'Technique' },
  administratif: { bg: 'bg-slate-100', text: 'text-slate-700', label: 'Administratif' },
  environnemental: { bg: 'bg-green-100', text: 'text-green-700', label: 'Environnemental' },
};

const fmt = (n: number) => Math.round(n).toLocaleString('fr-FR');

const IncidentCard: React.FC<IncidentCardProps> = ({ incident, onResoudre }) => {
  const config = typeConfig[incident.type] || typeConfig.alea;
  const isResolu = incident.statut === 'resolu';

  return (
    <div className={`p-3 rounded-lg border ${isResolu ? 'bg-gray-50 border-gray-200' : 'bg-white border-gray-200'}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <span className={`px-2 py-0.5 text-[10px] font-semibold rounded-full ${config.bg} ${config.text} flex-shrink-0`}>
            {config.label}
          </span>
          <h4 className={`text-sm font-medium truncate ${isResolu ? 'text-gray-500' : 'text-gray-900'}`}>
            {incident.titre}
          </h4>
        </div>
        {!isResolu && onResoudre && (
          <button
            onClick={() => onResoudre(incident.id)}
            className="flex items-center gap-1 text-xs text-emerald-600 hover:text-emerald-700 font-medium flex-shrink-0 transition-colors"
          >
            <CheckCircleIcon className="w-4 h-4" />
            Résoudre
          </button>
        )}
        {isResolu && (
          <span className="text-[10px] text-emerald-600 font-medium flex-shrink-0">Résolu</span>
        )}
      </div>

      <p className={`text-xs mt-1 ${isResolu ? 'text-gray-400' : 'text-gray-600'}`}>
        {incident.description}
      </p>

      <div className="flex items-center gap-4 mt-2 text-[11px] text-gray-400">
        <span>Déclaré le {new Date(incident.dateDeclaration).toLocaleDateString('fr-FR')}</span>
        {incident.impactFinancierEstime != null && incident.impactFinancierEstime > 0 && (
          <span className="text-amber-600 font-medium">{fmt(incident.impactFinancierEstime)} €</span>
        )}
        {incident.impactDelaiEstime != null && incident.impactDelaiEstime > 0 && (
          <span className="text-amber-600 font-medium">{incident.impactDelaiEstime} sem.</span>
        )}
        {incident.dateResolution && (
          <span className="text-emerald-500">Résolu le {new Date(incident.dateResolution).toLocaleDateString('fr-FR')}</span>
        )}
      </div>
    </div>
  );
};

export default IncidentCard;
